export const calculateCaffetteriaTotalPrice = (data, currentCurrency, type) => {//! type 0 === oldData 1 === newData with paymentDetails
  let cafeteria = 0;
  let otherRevenue = 0;
  // console.log(data, currentCurrency, type)
  if (type === 0) {
    data.forEach((dt) => {
      if (dt.type === 0 || dt.type === 1)
        cafeteria += (currentCurrency === 'IQD' ? dt.iqd : dt.price) || 0;
      else
        otherRevenue += (currentCurrency === 'IQD' ? dt.iqd : dt.price) || 0;
    });
    return { cafeteria, otherRevenue };
  } else {
    //!cafeteria 
    let dataa = {
      balance: {
        totalMoneyReceived: { dollar: 0, iqd: 0 },
        totalChange: { iqd: 0, dollar: 0 },
        totalAvailable: { iqd: 0, dollar: 0 }
      },
      cash: {
        totalMoneyReceived: { dollar: 0, iqd: 0 },
        totalChange: { iqd: 0, dollar: 0 },
        totalAvailable: { iqd: 0, dollar: 0 }
      },
      card: {
        totalMoneyReceived: { dollar: 0, iqd: 0 },
        totalChange: { iqd: 0, dollar: 0 },
        totalAvailable: { iqd: 0, dollar: 0 }
      },
      otherRevenue: {
        totalMoneyReceived: { dollar: 0, iqd: 0 },
        totalChange: { iqd: 0, dollar: 0 },
        totalAvailable: { iqd: 0, dollar: 0 }
      },
      physicalTherapy: {
        totalMoneyReceived: { dollar: 0, iqd: 0 },
        totalChange: { iqd: 0, dollar: 0 },
        totalAvailable: { iqd: 0, dollar: 0 }
      }
    }
    data.map((membership) => {
      const { paymentDetails } = membership
      const { payedType } = paymentDetails
      const checkCurrency = payedType === 0 ? 'dollar' : payedType === 1 ? 'iqd' : 'both'

      let type = membership.type === 0 ? 'cash' : membership.type === 1 ? 'balance' : membership.type === 7 ? "physicalTherapy" : membership.type === 6 ? 'card' : 'otherRevenue'
      // console.log({type})
      if (checkCurrency === 'both') {
        dataa[type].totalMoneyReceived.dollar += paymentDetails.dollarAmount
        dataa[type].totalMoneyReceived.iqd += paymentDetails.iqdAmount
      } else {
        dataa[type].totalMoneyReceived[checkCurrency] += paymentDetails.amountByCustomer
      }
      if (paymentDetails.changeType === 1) {
        dataa[type].totalChange.iqd += paymentDetails.changePrice
      } else if (paymentDetails.changeType === 0) {
        dataa[type].totalChange.dollar += paymentDetails.changePrice
      } else {
        dataa[type].totalChange.iqd += paymentDetails.iqdChange
        dataa[type].totalChange.dollar += paymentDetails.dollarChange
      }

      if (payedType === 0) {
        dataa[type].totalAvailable.dollar += (paymentDetails.amountByCustomer)
      } else if (payedType === 1) {
        dataa[type].totalAvailable.iqd += (paymentDetails.amountByCustomer)
      } else if (payedType === 2) {
        dataa[type].totalAvailable.dollar += (paymentDetails.dollarAmount)
        dataa[type].totalAvailable.iqd += (paymentDetails.iqdAmount)
      }
    })

    dataa.balance.totalAvailable.iqd -= dataa.balance.totalChange.iqd
    dataa.balance.totalAvailable.dollar -= dataa.balance.totalChange.dollar
    dataa.otherRevenue.totalAvailable.iqd -= dataa.otherRevenue.totalChange.iqd
    dataa.otherRevenue.totalAvailable.dollar -= dataa.otherRevenue.totalChange.dollar

    return dataa
  }


};
